/**
 * Shared pricing formulas — used by both client (UI display) and server (invoice creation).
 * Server is authoritative; client uses these for preview only.
 */

/** Dynamic Stars price for x3 reward multiplier */
export function getMultiplierStarsPrice(baseReward: number): number {
  return Math.max(3, Math.round(Math.sqrt(baseReward) * 0.22));
}

/**
 * Approximation of MetaConfig.GetLevelFinishReward for server-side calculation.
 * Mirrors: Start=200, GainBalance=[[0, 160]]
 * Formula: 200 + (level - 1) * 160
 */
export function getRewardForLevel(level: number): number {
  return 200 + (level - 1) * 160;
}

/** Whether a booster level is a paywall gate (every 5 levels) */
export function isBoosterGateLevel(level: number): boolean {
  return level > 0 && level % 5 === 0;
}

/** Stars price to unlock the next tier of 5 booster levels.
 *  Exponential growth capped at maxTier — after that, price stays flat. */
export function getBoosterGatePrice(level: number, basePrice = 5, maxTier = 7): number {
  if (!isBoosterGateLevel(level)) return 0;
  const tierIndex = Math.min(Math.floor(level / 5), maxTier); // cap at maxTier
  return basePrice * Math.pow(2, tierIndex - 1);
}

/** Maximum booster level allowed for a given tier */
export function getBoosterMaxLevel(tier: number): number {
  return tier * 5;
}

/** Whether a booster at given level is gated for the given tier */
export function isBoosterGated(level: number, tier: number): boolean {
  return level >= getBoosterMaxLevel(tier);
}

export type BoosterKind = "spawn" | "startPop" | "offline";
